'use strict';
import { Howl } from 'howler';

class BGMController extends Howl {
  constructor(path, html5) {
    super({
      src: [path],
      preload: true,
      html5: html5,
      sprite: {
        proc_field03_pizza: [0, 16613.877551020407],
        proc_play03: [18000, 33175.510204081635],
      },
    });

    this.spriteKeys = ['proc_field03_pizza', 'proc_play03'];
  }

  hasKey(key) {
    return this.spriteKeys.includes(key);
  }
}

export default BGMController;
